<template>
    <div class="app-content">
        <div class="app-title mb10">
            <!-- 应用标题 -->
            <div class="app-titles">
                <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                <span class="app-title-main">{{currentSelectMenuData.name}}</span>
            </div>
            <!-- 列表按钮 -->
            <div class="app-buttons">
                <el-button icon="icon-add" class="btn-green" size="mini" @click="addBtn">
                    <font>新建</font>
                </el-button>
                <el-button icon="icon-trash-2" class="btn-red" size="mini" @click="delBtn">
                    <font>删除</font>
                </el-button>
                <el-button icon="icon-upload-cloud" class="btn-blue" size="mini" @click="release">
                    <font>发布</font>
                </el-button>
                <el-button icon="icon-download-cloud" class="btn-blue" size="mini">
                    <font>导出</font>
                </el-button>
                <el-button icon="icon-print" class="btn-blue" size="mini">
                    <font>打印</font>
                </el-button>
            </div>
        </div>
        <!-- 列表右侧控制列 -->
        <div class="app-control" v-drag>
            <!-- 高级搜索按钮 -->
            <el-button title="高级搜索" size="mini" type="primary" icon="icon-search" @click="drawer = !drawer"></el-button>
        </div>
        <!-- 列表高级搜索 -->
        <el-drawer class="mainSearchdrawer" title="高级搜索" :with-header="false" :visible.sync="drawer" size="260px">
            <el-row :gutter="20">
                <el-form inline-message :model="searchList" label-width="100">
                    <el-col :span="24">
                        <el-form-item label="模型名称">
                            <el-input size="mini" v-model="searchList.name" @keyup.enter.native="searchBtn"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="类型">
                            <el-input size="mini" v-model="searchList.category" @keyup.enter.native="searchBtn"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-button size="mini" type="primary" style="width:100%;background: #08979c;border:none" @click="searchBtn">搜索</el-button>
                    </el-col>
                    <el-col :span="24" style="margin-top:10px">
                        <el-button class="resetBtn" size="mini" style="width:100%" @click="resetBtn">重置</el-button>
                    </el-col>
                </el-form>
            </el-row>
        </el-drawer>
        <!-- 高级搜索 -->
        <div class="mb5 mt5 app-filterData">
            <template>
                <el-tag @close="closeSearchTagBtn('name')" class="ml5 mt5 mb5" size="small" v-if="!!searchList.name" closable>{{'模型名称：' + searchList.name}}</el-tag>
                <el-tag @close="closeSearchTagBtn('category')" class="ml5 mt5 mb5" size="small" v-if="!!searchList.category" closable>{{'类型：' + searchList.category}}</el-tag>
            </template>
        </div>
        <!-- 表格 -->
        <el-table class="app-table" ref="vtable" :data="tableData" row-key="id" stripe highlight-current-row :height="fullHeight" @selection-change="selectTableData" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <el-table-column type="selection" width="55" :reserve-selection="true">
            </el-table-column>
            <el-table-column prop="idid" label="编号" :show-overflow-tooltip="true">
                <template slot-scope="props">
                    <span class="blue" title="点击查看详情" @click="viewBtn(props.row)">{{props.row.id}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="模型名称" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column align="center" width="100" prop="key" label="模型标识" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column align="center" width="100" prop="category" label="类型" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column align="center" width="100" prop="version" label="模型版本" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column align="center" width="100" prop="createTime" label="录入时间" :show-overflow-tooltip="true">
            </el-table-column>
        </el-table>
        <div class="pt10 text-right">
            <el-pagination @size-change="sizeChange" background @current-change="currentChange" :current-page="page.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next" :total="page.totalCount">
            </el-pagination>
        </div>
        <flowmanagementdetail ref="flowmanagementdetail" @requestData="getData('reset')"></flowmanagementdetail>
        <iframemask ref="childIframe"></iframemask>
    </div>
</template>

<script>

import flowmanagementdetail from "./flow_managementdetail"
import iframemask from './iframe.vue'
export default {
    name:"flow_management",
    components:{
        flowmanagementdetail,
        iframemask
    },
    data(){
        return{
            tableData:[],
            page: {
                currentPage: 1,
                pageSize: 20,
                totalCount: 0
            },
            fullHeight: document.documentElement.clientHeight - 133,//获取浏览器高度
            loading:false,
            selectTableList:[],
            basic_url: Config.dev_url,//请求地址
            drawer:false,
            searchList:{},
        }
    },
    directives:{
        drag:{
            bind:function(el){
                let odiv = el;
                odiv.onmousedown = (e) =>{
                    let disX = e.clientX - odiv.offsetLeft;
                    let disY = e.clientY - odiv.offsetTop;
                    document.onmousemove = (e) =>{
                        let left = e.clientX - disX;
                        let top = e.clientY - disY;
                        odiv.style.left = left + "px";
                        odiv.style.top = top + "px";
                    };
                    document.onmouseup = (e) =>{
                        document.onmousemove = null
                        document.onmouseup = null
                    }
                }
            }
        }
    },
    computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //列表显示的按钮
        listButtons(){
            return this.$store.state.buttons
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    },
    methods:{
        //删除高级搜索显示的某个tag
        closeSearchTagBtn(val){
            this.searchList[val] = ""
            if(!this.searchList.name && !this.searchList.category){
                this.getData();
            }else{                
                this.searchData()
            }            
        },
        //主表列表高级搜索
        searchBtn() {
            this.drawer = false
            this.searchData()
        },
        //主表列表重置按钮
        resetBtn() {
            this.searchList = {}
            this.drawer = false
            this.getData()
        },
        //查看数据详情
        viewBtn(item){
            this.$refs.childIframe.visible(item.id)
        },
        //新建按钮
        addBtn(){
            this.$refs.flowmanagementdetail.addBtn()
        },
        delBtn(){
            var selData = this.selectTableList;
            if (selData.length == 0) {
                this.$message({
                message: '请您选择要删除的数据',
                type: 'warning'
                });
                return;
            } else if (selData.length > 1) {
                this.$message({
                message: '不可同时删除多个数据',
                type: 'warning'
                });
                return;
            } else {
                var changeMenu = selData[0];
                var id = changeMenu.id
                var url = Config.dev_url + '/api-flow/flow/model/' + id;
                this.$axios.delete(url, {}).then((res) => { //.delete 传数据方法
                //resp_code == 0是后台返回的请求成功的信息
                if (res.data.code == 0) {
                    this.$message({
                    message: '删除成功',
                    type: 'success'
                    });
                    this.getData();
                }
                }).catch((err) => {
                });
            }
        },
        //发布
        release() {
            if (this.selectTableList.length == 0) {
                this.$message({
                message: '请您选择要发布的流程',
                type: 'warning'
                });
                return;
            } else if (this.selectTableList.length > 1) {
                this.$message({
                message: '不可同时发布多个流程',
                type: 'warning'
                });
                return;
            } else {
                var id = this.selectTableList[0].id;
                var url = Config.dev_url + '/api-flow/flow/model/' + id + '/deploy';
                this.$axios.get(url, {}).then((res) => {
                if (res.data.code == 0) {
                    this.$message({
                    message: res.data.msg,
                    type: 'success'
                    });
                    this.getData();
                } else {
                    this.$message({
                    message: res.data.msg,
                    type: 'warning'
                    });
                }
                }).catch((err) => {
                });
            }
        },
        //选中表格某条数据时触发
        selectTableData(val) {
            this.selectTableList = val
        },
        //高级搜索
        searchData(){
            var data = {
                name: this.searchList.name,
                category: this.searchList.category,
                page: this.page.currentPage,
                limit: this.page.pageSize
            }

            var url = Config.dev_url + '/api-flow/flow/model';
            this.$axios.get(url,{ params: data}).then((res)=>{
                this.loading = false
                this.tableData = res.data.data
                this.page.totalCount = res.data.count;
            }).catch((err) => {
            }); 
        },
        sizeChange(val) {
            this.page.pageSize = val;
            this.getData();
        },
        currentChange(val) {
            this.page.currentPage = val;
            this.getData();
        },
        //获取数据
        getData(str){
            if(str == 'reset'){
                this.tableData = []
            }
            this.page.currentPage = 1;
            this.page.pageSize = 20;
            var data = {
                page:1,
                limit:20
            };
            var url = Config.dev_url + '/api-flow/flow/model';
            this.$axios.get(url,{ params: data}).then((res)=>{
                this.$refs.vtable.clearSelection()
                this.loading = false
                this.tableData = res.data.data
                this.page.totalCount = res.data.count;
            }).catch((err) => {
            });            
        },
    },
    mounted(){
        this.getData();
    }
}
</script>

<style>

</style>